export type { IVirtualElement } from './dom/IVirtualElement';
export { elementContains } from './dom/elementContains';
export { elementContainsAttribute } from './dom/elementContainsAttribute';
export { findElementRecursive } from './dom/findElementRecursive';
export { getActiveElement } from './dom/getActiveElement';
export { getChildren } from './dom/getChildren';
export { getDocument } from './dom/getDocument';
export { getEventTarget } from './dom/getEventTarget';
export { getFirstVisibleElementFromSelector } from './dom/getFirstVisibleElementFromSelector';
export { getParent } from './dom/getParent';
export { getRect } from './dom/getRect';
export { getVirtualParent } from './dom/getVirtualParent';
export { getWindow } from './dom/getWindow';
export { isVirtualElement } from './dom/isVirtualElement';
export { on } from './dom/on';
export { portalContainsElement } from './dom/portalContainsElement';
export {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  raiseClick,
} from './dom/raiseClick';
export { DATA_PORTAL_ATTRIBUTE, setPortalAttribute } from './dom/setPortalAttribute';
export { setVirtualParent } from './dom/setVirtualParent';
